'use strict';

(function ($) {
    var methods = {
        init: function (options) {
            var opts = $.extend({}, $.fn.panelCollapsible.defaults, options);

            return this.each(function () {
                var _this = this;
                var $this = $(this);

                if ($this.hasClass('panel-collapsible-init')) {
                    return;
                }

                $this.addClass('panel-collapsible-init');

                $this.find('> .panel-heading').on('click', function () {
                    methods.toggle.apply(_this, [opts]);
                });

                if(opts.init) {
                    opts.init.apply(_this);
                }
            });
        },

        toggle: function (opts) {
            var _this = this;
            var $this = $(this);

            $this.toggleClass('panel-collapsed');

            var callback = null;
            if ($this.hasClass('panel-collapsed')) {
                callback = opts.close;
            } else {
                callback = opts.open;
            }

            if ($.isFunction(callback)) {
                callback.apply(_this);
            }
        }
    };

    $.fn.panelCollapsible = function (methodOrOptions) {
        if (methods[methodOrOptions]) {
            return methods[methodOrOptions].apply(this, Array.prototype.slice.call(arguments, 1));
        } else if (typeof methodOrOptions === 'object' || !methodOrOptions) {
            return methods.init.apply(this, arguments);
        } else {
            $.error('Method ' + methodOrOptions + ' does not exists on jQuery.panelCollapsible');
        }
    };

    $.fn.panelCollapsible.defaults = {
        /*events*/
        init: null,
        open: null,
        close: null
    };
})(jQuery);
